import { validateResponseHasSchema } from '@/shared/api/validation'
import { createAssetManagementClient } from '@/shared/api/client'
import { z } from 'zod'
import { AssetType } from '@/features/assets/constants'

const client = createAssetManagementClient()

export const checkAssetCreationEligibility = (projectCode: number) => validateResponseHasSchema(
  client.sendGet(`v2/assets/create/eligibility`, { projectCode }),
  z.object({
    data: z.object({
      unifiiProjectCode: z.number(),
      energyProProjectCode: z.number().nullable(),
      projectName: z.string(),
      projectAddress: z.string(),
      type: z.nativeEnum(AssetType),
      wheelingAllocationSize: z.number().nullable(),
    })
  })
).then(
  res => res.data
);
